<div class="forward by-owner">
    <div class="title">
      {{ title }} {{ 'step.forward.by_owner.title' | i18n }}
    </div>
    <form class="k-form" [formGroup]="form">
      <fieldset class="k-form-fieldset">
        <kendo-formfield showErrors="initial">
          <kendo-label [for]="currentResponsible" [text]="'step.forward.by_owner.currentResponsible.label' | i18n"></kendo-label>
          <circ-people-picker
            #currentResponsible
            formControlName="currentResponsible"
            [maxPeople]="1"
            [people]="people"
            [placeholder]="'step.forward.by_owner.currentResponsible.placeholder' | i18n"
          >
          </circ-people-picker>

          <kendo-formerror>
            <div *ngIf="form.controls.currentResponsible.errors?.required">
              {{ 'step.forward.by_owner.currentResponsible.label' | i18nRequiredField }}
            </div>
            <div *ngIf="form.controls.currentResponsible.errors?.singleSelection">
              {{ 'step_forward_formerror_tooManyPeople'  | i18n }}
            </div>
          </kendo-formerror>
        </kendo-formfield>
        <kendo-formfield showErrors="initial">
          <kendo-label [for]="responsible" [text]="'step_details_responsible' | i18n"></kendo-label>
          <sp-people-picker #responsible [maxPeople]="1"formControlName="responsible">
          </sp-people-picker>
          <kendo-formerror>
            <div *ngIf="form.controls.responsible.errors?.required">
              {{ 'step_details_responsible' | i18nRequiredField }}
            </div>
            <div *ngIf="form.controls.responsible.errors?.singleSelection">
              {{ 'step_forward_formerror_tooManyPeople'  | i18n }}
            </div>
          </kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="comment" [text]=" 'step_forward_label_comment' | i18n "></kendo-label>
          <textarea kendoTextArea formControlName="comment" #comment [autoSize]="true"></textarea>
        </kendo-formfield>
        <div class="k-form-buttons">
          <ece-btn-primary (click)="save()" [text]=" 'step_forward_button_save' | i18n"></ece-btn-primary>
          <ece-btn (click)="abort($event)" [text]=" 'step_forward_button_abort' | i18n"></ece-btn>
        </div>
      </fieldset>
    </form>
</div>
